import { isEmailValid } from 'ui/pages/helpers';
import { isCPFValid } from '../is-cpf-valid';

export const getUsernameMethod = (username: string) => {
  if (isEmailValid(username)) {
    return 'email';
  }
  if (isCPFValid(username)) {
    return 'cpf';
  }
  return 'id';
};
